import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedUiTableModule} from '@snelstart/ui-table';
import {SharedUiButtonModule} from "@snelstart/ui-button";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {SharedUiAlertModule} from "@snelstart/ui-alert";
import {SharedUiDialogModule} from "@snelstart/ui-dialog";
import {FeatureTaxBezwaarListComponent} from "./tax-bezwaar-list/feature-tax-bezwaar-list.component";
import {SharedUiIconModule} from "@snelstart/ui-icon";
import {SharedUiTooltipModule} from "@snelstart/ui-tooltip";

@NgModule({
  imports: [CommonModule, SharedUiTableModule, SharedUiButtonModule, SharedUiDetailsModule, SharedUiFormControlsModule, SharedUiAlertModule, SharedUiDialogModule, SharedUiIconModule, SharedUiTooltipModule, FeatureTaxBezwaarListComponent],
  declarations: [],
  exports: [FeatureTaxBezwaarListComponent],
})
export class FeatureTaxBezwaarListModule {
}
